import React, { Component } from 'react'
import { siteContent } from '@services/api'
import { Collapse, Button, Icon, Popconfirm } from 'antd'
import AddContent from './AddContent'
import AddAgency from './AddAgency'
import DeleteTable from './DeleteTable'
import SiteContent from '@pages/SiteContent'
import Embedded from '@pages/Embedded/Developer'
import InfoMsg from '@pages/InfoMsg/Developer'

export default class extends Component {
    state = { components: [], arr: [], isLoading: false }
    updateSiteContent = async () => {
        await this.setState({ isLoading: true })
        siteContent.getSiteContent().then(res =>
            this.setState(
                {
                    components: res.data.map(slot => {
                        return { ...slot, keys: JSON.parse(slot.keys) }
                    })
                },
                () => {
                    let arr = []
                    this.state.components.map(slot => {
                        Object.entries(slot.keys).map(([key, value]) =>
                            arr.push({
                                id: slot.id,
                                component: slot.component,
                                lng: slot.lng,
                                key: { key, value },
                                updated_by: slot.updated_by,
                                updated_at: slot.updated_at
                            })
                        )
                    })
                    this.setState({ arr, isLoading: false })
                }
            )
        )
    }

    newAgency = async () => {
        // await this.setState({ isLoading: true })
        // siteContent.getSiteContent().then(res =>
        //     this.setState(
        //         {
        //             components: res.data.map(slot => {
        //                 return { ...slot, keys: JSON.parse(slot.keys) }
        //             })
        //         },
        //         () => {
        //             let arr = []
        //             this.state.components.map(slot => {
        //                 Object.entries(slot.keys).map(([key, value]) =>
        //                     arr.push({
        //                         id: slot.id,
        //                         component: slot.component,
        //                         lng: slot.lng,
        //                         key: { key, value },
        //                         updated_by: slot.updated_by,
        //                         updated_at: slot.updated_at
        //                     })
        //                 )
        //             })
        //             this.setState({ arr, isLoading: false })
                // }
            // )
        // )
    }

    componentDidMount() {
        this.updateSiteContent()
    }
    getDltIcon = id => {
        return (
            <Popconfirm
                title={`האם אתה בטוח שברצונך למחוק קומפננטה זו?`}
                okText="כן"
                cancelText="ביטול"
                onConfirm={async event => {
                    event.stopPropagation()
                    event.preventDefault()
                    await siteContent.deleteComp(id)
                    this.updateSiteContent()
                }}
            >
                <Button
                    onClick={event => {
                        event.stopPropagation()
                        event.preventDefault()
                    }}
                >
                    <Icon type="delete" />
                </Button>
            </Popconfirm>
        )
    }
    render() {
        const { components, arr, isLoading } = this.state
        const { Panel } = Collapse
        return (
            !isLoading &&
            components.length && (
                <Collapse accordion style={{ flexDirection: 'column' }}>
                    <Panel header={'הוסף לקומפוננטה קיימת'}>
                        <Collapse accordion style={{ flexDirection: 'column' }}>
                            {components
                                .sort((a, b) => +(a.component > b.component) * 2 - 1)
                                .filter(item => item.component != 'faq_')
                                .map(item => (
                                    <Panel header={item.component} key={item.id} extra={this.getDltIcon(item.id)}>
                                        <AddContent
                                            compName={item.component}
                                            id={item.id}
                                            updateSiteContent={this.updateSiteContent}
                                            arr={arr}
                                        />
                                    </Panel>
                                ))}
                        </Collapse>
                    </Panel>
                    <Panel header={'צור קומפוננטה'}>
                        <AddContent compName={''} updateSiteContent={this.updateSiteContent} arr={arr} />
                    </Panel>
                    <Panel header={'מצא כפילוית באתר'}>
                        <DeleteTable
                            updateSiteContent={this.updateSiteContent}
                            arr={arr.filter(
                                (item, idx) => idx != arr.map(item => item.key.value).indexOf(item.key.value)
                            )}
                        />
                    </Panel>
                    <Panel header={'טבלת חיפוש ע"פ מפתח'}>
                        <SiteContent isDeveloper />
                    </Panel>
                    <Panel header={'הוספת embedded'}>
                        <Embedded />
                    </Panel>
                    <Panel header="הוספת info-msg">
                        <InfoMsg />
                    </Panel>
                    <Panel header={'הוספת סוכן/סוכנות למערכת'}>
                        <AddAgency/>
                    </Panel>
                </Collapse>
            )
        )
    }
}
